<div class="organization-logo d-flex align-items-center">
  @if (redirectEnabled) {
    <a
      [attr.href]="windowOrigin"
      appUnsavedFormCheck
      class="organization-logo__href w-100 h-100"
    >
      <img
        [alt]="alt"
        [src]="organizationLogo"
        appDefaultPlaceholder
        appDynamicImgUrl
      />
    </a>
  } @else {
    <img
      [alt]="alt"
      [src]="organizationLogo"
      appDefaultPlaceholder
      appDynamicImgUrl
      class="w-100"
    />
  }

  @if (showCopyText) {
    <button
      (click)="$event.stopPropagation()"
      class="organization-logo__text-copy btn-unstyled"
    >
      <app-copy-text [textToCopy]="filterTokenUrl"></app-copy-text>
    </button>
  }
</div>
